/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OtherSystemSourceWithCentreAndDomainProjectCentre } from './OtherSystemSourceWithCentreAndDomainProjectCentre';
import {
    OtherSystemSourceWithCentreAndDomainProjectCentreFromJSON,
    OtherSystemSourceWithCentreAndDomainProjectCentreFromJSONTyped,
    OtherSystemSourceWithCentreAndDomainProjectCentreToJSON,
    OtherSystemSourceWithCentreAndDomainProjectCentreToJSONTyped,
} from './OtherSystemSourceWithCentreAndDomainProjectCentre';
import type { OtherSystemSourceWithCentreAndDomainProjectDomain } from './OtherSystemSourceWithCentreAndDomainProjectDomain';
import {
    OtherSystemSourceWithCentreAndDomainProjectDomainFromJSON,
    OtherSystemSourceWithCentreAndDomainProjectDomainFromJSONTyped,
    OtherSystemSourceWithCentreAndDomainProjectDomainToJSON,
    OtherSystemSourceWithCentreAndDomainProjectDomainToJSONTyped,
} from './OtherSystemSourceWithCentreAndDomainProjectDomain';
import type { OtherSystemSource } from './OtherSystemSource';
import {
    OtherSystemSourceFromJSON,
    OtherSystemSourceFromJSONTyped,
    OtherSystemSourceToJSON,
    OtherSystemSourceToJSONTyped,
} from './OtherSystemSource';

/**
 * 
 * @export
 * @interface OtherSystemSourceWithCentreAndDomain
 */
export interface OtherSystemSourceWithCentreAndDomain {
    /**
     * 
     * @type {OtherSystemSource}
     * @memberof OtherSystemSourceWithCentreAndDomain
     */
    otherSystemSource?: OtherSystemSource;
    /**
     * 
     * @type {OtherSystemSourceWithCentreAndDomainProjectCentre}
     * @memberof OtherSystemSourceWithCentreAndDomain
     */
    projectCentre?: OtherSystemSourceWithCentreAndDomainProjectCentre | null;
    /**
     * 
     * @type {OtherSystemSourceWithCentreAndDomainProjectDomain}
     * @memberof OtherSystemSourceWithCentreAndDomain
     */
    projectDomain?: OtherSystemSourceWithCentreAndDomainProjectDomain | null;
}

/**
 * Check if a given object implements the OtherSystemSourceWithCentreAndDomain interface.
 */
export function instanceOfOtherSystemSourceWithCentreAndDomain(value: object): value is OtherSystemSourceWithCentreAndDomain {
    return true;
}

export function OtherSystemSourceWithCentreAndDomainFromJSON(json: any): OtherSystemSourceWithCentreAndDomain {
    return OtherSystemSourceWithCentreAndDomainFromJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSourceWithCentreAndDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'otherSystemSource': json['otherSystemSource'] == null ? undefined : OtherSystemSourceFromJSON(json['otherSystemSource']),
        'projectCentre': json['projectCentre'] == null ? undefined : OtherSystemSourceWithCentreAndDomainProjectCentreFromJSON(json['projectCentre']),
        'projectDomain': json['projectDomain'] == null ? undefined : OtherSystemSourceWithCentreAndDomainProjectDomainFromJSON(json['projectDomain']),
    };
}

export function OtherSystemSourceWithCentreAndDomainToJSON(json: any): OtherSystemSourceWithCentreAndDomain {
    return OtherSystemSourceWithCentreAndDomainToJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainToJSONTyped(value?: OtherSystemSourceWithCentreAndDomain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'otherSystemSource': OtherSystemSourceToJSON(value['otherSystemSource']),
        'projectCentre': OtherSystemSourceWithCentreAndDomainProjectCentreToJSON(value['projectCentre']),
        'projectDomain': OtherSystemSourceWithCentreAndDomainProjectDomainToJSON(value['projectDomain']),
    };
}

